const pathToCnMap = {
  index: "首页",
  informationService: "信息服务",
  detail: "内容详情",
  hotNews: "热点问题",
  patentService: "专利服务",
  patentAnalysis: "专利分析",
  expertResources: "专家资源",
  basicKnowledge: "基础知识",
  agencyService: "代理服务",
  resourceNavigation: "资源导航",
  activity: "内容详情",
  service: "内容详情",
  policy: "政策法规",
  news: "新闻速递",
  analysis: "分析报告",
  compete: "竞赛动态",
  lecture: "素养教育",
  consult: "相关咨询",
};

function getCurrentCrumb(path) {
  const paths = path.split("/").filter(Boolean); // 获取所有路径
  return paths.reduce((pre, cur) => {
    pre.push({
      name: pathToCnMap[cur],
      toRouter: cur,
    });
    return pre;
  }, []);
}
function getResolveCrumb(path, name) {
  const paths = path.split("/").filter(Boolean); // 获取所有路径
  return paths.reduce((pre, cur) => {
    if (cur === "index") {
      pre.push({
        name: name,
        toRouter: cur,
      });
    } else {
      pre.push({
        name: pathToCnMap[cur],
        toRouter: cur,
      });
    }
    return pre;
  }, []);
}

module.exports = {
  getCurrentCrumb,
  getResolveCrumb,
};
